module.exports = __webpack_public_path__ + "static/media/craigslistlogo.a52bad1d.svg";